<template>
    <button
        type="button"
        class="timesheet-assessment-link"
        :class="incomplete ? 'is-incomplete' : 'is-complete'"
        @click="$emit('click')"
    >
        <i class="fas fa-user-check" aria-hidden="true"></i>
        <span>
            <strong>КТУ и характеристика за месяц</strong>
            <small>{{ status }}</small>
        </span>
        <i class="fas fa-chevron-right" aria-hidden="true"></i>
    </button>
</template>

<script>
export default {
    name: 'TimesheetAssessmentLink',
    props: {
        incomplete: {type: Boolean, default: false},
        status: {type: String, required: true}
    }
};
</script>

<style scoped lang="scss">
.timesheet-assessment-link {
    display: grid;
    grid-template-columns: 32px minmax(0, 1fr) 12px;
    gap: .5rem;
    align-items: center;
    width: 100%;
    margin: 0 0 .65rem;
    padding: .55rem .65rem;
    border: 1px solid #cbd8e3;
    border-radius: 10px;
    color: #31536d;
    background: #f5f8fb;
    text-align: left;
}

.timesheet-assessment-link > i:first-child {
    font-size: 1rem;
    text-align: center;
}

.timesheet-assessment-link > span,
.timesheet-assessment-link strong,
.timesheet-assessment-link small {
    display: block;
    min-width: 0;
}

.timesheet-assessment-link strong {
    color: inherit;
    font-size: .75rem;
}

.timesheet-assessment-link small {
    margin-top: .1rem;
    overflow: hidden;
    color: #66788a;
    font-size: .66rem;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.timesheet-assessment-link.is-incomplete {
    border-color: #e1b45f;
    color: #9a5c00;
    background: #fff0c2;
}

.timesheet-assessment-link.is-complete {
    border-color: #acd4b8;
    color: #276749;
    background: #dff4e5;
}
</style>
